import { render, staticRenderFns } from "./PaymentTicker.vue?vue&type=template&id=a1c31c2a&scoped=true&"
import script from "./PaymentTicker.vue?vue&type=script&lang=js&"
export * from "./PaymentTicker.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTicker.vue?vue&type=style&index=0&id=a1c31c2a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c31c2a",
  null
  
)

export default component.exports